export default __webpack_public_path__ + "a6a5c6d59055abba528b8fb7d1abc0b1.svg";